
import ProductOptions from './components/ProductOptions.vue';

export default {
  i18nComponentKey: 'WidgetProductReviewsProductOptions.WidgetProductReviewsProductOptionsMobile',
  name: 'WidgetProductReviewsProductOptionsMobile',
  components: { ProductOptions }
};
